module.exports = __webpack_public_path__ + "static/media/mobile_articles.43e0c0d4.png";


//////////////////
// WEBPACK FOOTER
// ../images/screenshots/mobile_articles.png
// module id = 658
// module chunks = 0